<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto text-center">

            <canvas id="firmaDigital"></canvas>


            <button type="button" id="ValidarFirma" v-if="firmaValidada == false" class="text-center btn btn-primary btn-lg" @click="ValidarRespuesta()">✅ <b><u>Pulse aquí</u></b> para poder <b>validar</b> la firma</button>

            <div class="form-check mx-lg-auto" style="font-size:9pt; text-align: justify; padding-top:20px;" v-if="lopd == 'yes'">
                <input class="form-check-input" type="checkbox" v-if="checklopd" checked @click="checklopdClick()">
                <input class="form-check-input" type="checkbox" v-else @click="checklopdClick()">

                <label class="form-check-label">
                    <p @click="checklopdClick()" v-if="insurance_name != ''">
                        Acepto que <b>{{company_name}}</b>, agencia vinculada de <u><strong>{{insurance_name}}</strong></u>, trate los datos que han sido recogidos en este formulario,  con la finalidad de intervenir como mediador en la contratación de las coberturas solicitadas. 
                        También acepta que  <u><strong>{{insurance_name}}</strong></u>, utilice estos datos para <i>la tarificación, emisión, cobro, gestión aseguradora del riesgo y servicios aparejados</i> recogido en la documentación contractual específica del seguro.
                    </p>
                    <p @click="checklopdClick()" v-else>
                        Acepto que <b>{{company_name}}</b>, <u>agencia vinculada de seguros</u>, trate los datos que han sido recogidos en este formulario,  con la finalidad de intervenir como mediador en la contratación de las coberturas solicitadas. 
                        También acepta que la <u><strong>COMPAÑÍA ASEGURADORA</strong></u>, utilice estos datos para <i>la tarificación, emisión, cobro, gestión aseguradora del riesgo y servicios aparejados</i> recogido en la documentación contractual específica del seguro.
                    </p>
                </label>
            </div>
        </div>
    </div>
</template>

<script>



import SignaturePad from "signature_pad"

export default {
  name: 'Firma',
  props: {

      response: String,
      FormularioTag: String,
      idQuestion: Number,
      lopd: String


  },
  data: function(){

      return {

        firmaDigital : null,
        firmaValidada: false,
        checklopd: true,
        company_name: "ALGORITMICA",
        insurance_name: ""
        
      }



  },
  mounted(){

    this.ResizeCanvas();

     if (company_name) {

        this.company_name = company_name;

    }

    if (insurance_name) {

            this.insurance_name = insurance_name;

    }


  },
  created () {

    window.addEventListener('resize', this.ResizeCanvas);

  },
  destroyed () {

    window.removeEventListener('resize', this.ResizeCanvas);

  },

  methods: {


      ResizeCanvas: function(){
        
        var canvas = document.querySelector("canvas");


        if (this.firmaDigital == null)
        {

            this.firmaDigital = new SignaturePad(canvas, {
                penColor: "rgb(0,0,0)",
                backgroundColor: "rgb(255,255,255)"
            });
            
        }


        var ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);


        if (this.firmaDigital.isEmpty())
        {

            this.firmaDigital.clear(); // otherwise isEmpty() might return incorrect value

        }



        if (this.response != null)
        {

            this.firmaDigital.fromDataURL(this.response);


        }

      },

      ValidarRespuesta : function(){

        if (this.firmaDigital != null && this.firmaDigital.isEmpty() == false)
        {
           
            this.firmaValidada = true;


        } else {
            
            this.firmaValidada = false;

        }


        if (this.firmaValidada == true && this.checklopd == true)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.firmaDigital.toDataURL()
            };
            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);

        }
        
        document.getElementById("ControlFormulario").scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});

        //document.getElementById("ControlFormulario").scrollIntoView({behavior: 'smooth'});

      },

      checklopdClick : function(){


        if (this.checklopd == true)
        {

            this.checklopd = false;

            if (this.firmaValidada == true)
            {

                let Mutation = {

                    formulario: this.FormularioTag,
                    question: this.idQuestion,
                    validate: false,
                    response: this.firmaDigital.toDataURL()
                };
                
                this.$store.commit('actualizarRespuestaFormulario', Mutation);

            }


        } else {

            this.checklopd = true;

            if (this.firmaValidada == true)
            {

                let Mutation = {

                    formulario: this.FormularioTag,
                    question: this.idQuestion,
                    validate: true,
                    response: this.firmaDigital.toDataURL()
                };
                
                this.$store.commit('actualizarRespuestaFormulario', Mutation);

            }

        }


        this.ValidarRespuesta();


      }


  }
}
</script>
<style scoped>
    #firmaDigital {
        margin: 0 auto;
        width: 100%;
        height: 30%;
        min-height: 250px;
        max-height: 300px;
        border: 1px solid #000;
        background-color: #fff;
        margin-bottom:20px;

    }


</style>